import { NgModule } from "@angular/core";
import { DefaultModules } from "src/app/services/app.constants";
import { SettingsComponent } from "./settings.component";
import { CheckboxModule } from "primeng/checkbox";
import { ReactiveFormsModule } from "@angular/forms";
import { ButtonModule } from "primeng/button";
import { InputSwitchModule } from "primeng/inputswitch";
import { CalendarModule } from "primeng/calendar";

@NgModule({
  declarations: [SettingsComponent],
  imports: [
    ...DefaultModules,
    CheckboxModule,
    ButtonModule,
    InputSwitchModule,
    CalendarModule,
    ReactiveFormsModule
  ],
  exports: [SettingsComponent]
})
export class SettingsModule { }
